import { Check, ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import { cn } from '@/shared/lib/utils'

import { LEAD_SOURCE_OPTIONS, LEAD_SOURCES } from '../../constants/leads'

export function SourceFilterDropdown({ value = LEAD_SOURCES.ALL, onChange }) {
  const [open, setOpen] = useState(false)
  const active =
    LEAD_SOURCE_OPTIONS.find((option) => option.value === value) ||
    LEAD_SOURCE_OPTIONS[0]

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="lg"
          className="h-11 w-full gap-2 rounded-full border-black/[0.08] bg-white px-5 text-sm font-semibold shadow-sm sm:w-auto"
        >
          <span className="truncate">{active.label}</span>
          {open ? (
            <ChevronUp className="size-4 shrink-0 text-muted-foreground" />
          ) : (
            <ChevronDown className="size-4 shrink-0 text-muted-foreground" />
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-[min(13rem,calc(100vw-2rem))]"
      >
        <DropdownMenuLabel>Filter by source</DropdownMenuLabel>
        <DropdownMenuSeparator />

        {LEAD_SOURCE_OPTIONS.map((option) => {
          const selected = option.value === value

          return (
            <DropdownMenuItem
              key={option.value}
              onSelect={() => onChange?.(option.value)}
              className={cn(
                'justify-between',
                selected && 'bg-primary/5 text-primary',
              )}
            >
              <span>{option.label}</span>
              {selected ? <Check className="size-4 text-primary" /> : null}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
